module.exports = __webpack_public_path__ + "static/img/a4.2df70f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/attestation/a4.png
// module id = U5lp
// module chunks = 0